<template>
  <div
    v-if="showModal"
    class="modal fade"
    :class="{ show: showModal }"
    :style="{ display: showModal ? 'block' : 'none' }"
    tabindex="-1"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, watch } from 'vue'
export interface Props {
  showModal: boolean
}
const props = withDefaults(defineProps<Props>(), {
  showModal: false
})
const close = defineEmits(['close'])

const addKeyListener = () => {
  removeKeyListener()
  document.addEventListener('keyup', onKeyListener)
}

const removeKeyListener = () => {
  document.removeEventListener('keyup', onKeyListener)
}

const onKeyListener = (event: KeyboardEvent) => {
  const keys = ['escape', '27']
  if (event.key) {
    const key = event.key.toLowerCase()

    if (keys.includes(key)) {
      close('close')
      return
    }
  }
  if (event.code) {
    const code = event.code.toLowerCase()

    if (keys.includes(code)) {
      close('close')
      return
    }
  }
}

onMounted(() => {
  addKeyListener()
})

onBeforeUnmount(() => {
  removeKeyListener()
})
watch(
  () => props.showModal,
  newVal => {
    if (newVal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }
)
</script>

<style scoped lang="scss">
.modal-window-wrapper > div {
  z-index: 1050;
  width: 100%;
}

.modal-window {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  transform: none;
  z-index: 1050;
}

.modal-window-overlay {
  content: '';
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background: var(--dealer-primary-light);
  opacity: 0.6;
  cursor: pointer;
}

.modal-dialog {
  position: fixed !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  place-content: center;
  place-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s ease-in-out;
}

.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-40%);
}
</style>
